var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"num-counter",attrs:{"aria-label":_vm.ariaLabel}},[_vm._v("\n    "+_vm._s(_vm.displayValue)+_vm._s(_vm.suffix)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }